import { CurrencyPipe } from '@angular/common';
import {
  Component,
  effect,
  inject,
  model,
  OnInit,
  signal,
} from '@angular/core';

import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucidePenLine,
  lucidePackage,
  lucideTrash2,
} from '@ng-icons/lucide';
import { CrudService } from '../../core/services/crud.service';
import { ProductFormComponent } from '../product-form/product-form.component';

@Component({
  selector: 'app-product-list',
  imports: [NgIcon, CurrencyPipe, ProductFormComponent],
  viewProviders: [
    provideIcons({
      lucidePenLine,
      lucidePackage,
      lucideTrash2,
    }),
  ],
  templateUrl: './product-list.component.html',
  styles: ``,
})
export class ProductListComponent implements OnInit {
  private crudService = inject(CrudService);
  products: Array<any> = [];

  existingProduct: any;

  showModal = model(false);

  constructor() {
    effect(() => {
      if (!this.showModal()) {
        this.getProducts();
      }
    });
  }

  ngOnInit(): void {
    // this.getProducts();
  }

  openModal() {
    this.existingProduct = null;
    this.showModal.set(true);
  }

  getProducts() {
    this.crudService.getProducts().subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.products = response.body;
        }
      },
    });
  }

  updateProduct(product: any) {
    this.existingProduct = product;
    this.showModal.set(true);
  }

  deleteProduct(productId: number) {
    this.crudService.deleteProduct(productId).subscribe({
      next: (response: any) => {
        if (response.ok) {
          // this.getCategories();
          this.getProducts();
        }
      },
    });
  }
}
